import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class ButtonDisablerService {
  private readonly subscriptions: {
    [key: string]: { state: boolean, subscription: Subject<boolean>, locked?: boolean }
  };

  constructor() {
    this.subscriptions = {};
  }

  wait(name: string): Observable<boolean> {
    return this.subscriptions[name].subscription.asObservable();
  }

  register(name: string): void {
    if (this.subscriptions[name]) {
      this.subscriptions[name].state = false;
      this.subscriptions[name].subscription.next(false);
      return;
    }
    this.subscriptions[name] = {
      state: false,
      subscription: new Subject<boolean>(),
      locked: false,
    };
  }

  unlock(name): void {
    if (!this.subscriptions[name]) {
      return;
    }

    this.subscriptions[name].locked = false;
  }

  unlockAll(): void {
    for (let key in this.subscriptions) {
      this.unlock(key);
    }
  }

  trigger(name: string, value: boolean, lock: boolean = false): void {
    if (!this.subscriptions[name]) {
      return;
    }
    this.subscriptions[name].state = value;
    if (lock) {
      this.subscriptions[name].locked = lock;
    }
    this.subscriptions[name].subscription.next(value);
  }

  remove(name: string): void {
    if (!this.subscriptions[name]) {
      return;
    }
    if (this.subscriptions[name].locked) {
      return;
    }
    this.subscriptions[name].subscription.next(false);
    this.subscriptions[name].subscription.complete();
    delete this.subscriptions[name];
  }

  disableActive(): void {
    for (const name in this.subscriptions) {
      if (this.subscriptions.hasOwnProperty(name)) {
        if (!this.subscriptions[name].locked) {
          setTimeout(() => this.trigger(name, false), 2000);
        }
      }
    }
  }
}
